<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs"/>
    <b-row>
      <b-col class="mb-3" lg="6">
        <b-card title="My Vos Voco Reporting Dashboard">
          <p class="card-text">
            Choose from the options below to filter your results here. You can save any chart, or export its data, by clicking the button above it.
          </p>
          <report-filters :workflows="workflows" v-model="filters" v-on:update:filters="updateFilters"></report-filters>
        </b-card>
      </b-col>
      <b-col class="mb-3" lg="6">
        <b-card header="Reporting Actions">
          <b-list-group>
            <b-list-group-item :to="{ path: '/reporting/report', query: { type: 'table' } }" class="align-items-start">
              <div class="d-flex">
                <div class="d-flex flex-column justify-content-center pr-3">
                  <icon name="report" size="22"/>
                </div>
                <div class="w-100">
                  <h5 class="mb-0">Run a Report</h5>
                  <p class="mb-0">Filter event data and view the results in a table.</p>
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <p class="mb-0">&gt;</p>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item :to="{ path: '/reporting/report', query: { type: 'download' } }" class="align-items-start">
              <div class="d-flex">
                <div class="d-flex flex-column justify-content-center pr-3">
                  <icon name="download" size="22"/>
                </div>
                <div class="w-100">
                  <h5 class="mb-0">Export Data</h5>
                  <p class="mb-0">Download data in various formats, for use in spreadsheets or to import into other systems.</p>
                </div>
                <div class="d-flex flex-column justify-content-center">
                  <p class="mb-0">&gt;</p>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
    <div v-if="workflow">
      <h4>All Events</h4>
      <b-row>
        <b-col class="mb-3">
          <line-chart element-id="all-events" :group-by="groupBy" :filters="filters" :header="'Total Events, ' + this.groupByDescription" allowTrend="true":linkToReport="true">
          </line-chart>
        </b-col>
      </b-row>
      <h4>Root Causes</h4>
      <b-row>
        <b-col lg="4" md="6" class="mb-3" v-for="rootCause in workflow.root_causes" :key="rootCause.id">
          <bar-chart :element-id="'root-cause-' + rootCause.id" :group-by="groupBy" :filters="rootCauseFilters(rootCause)" sort="false" allowTrend="true" :header="rootCause.name" :linkToReport="true">
          </bar-chart>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import API from '@/lib/api'
import DatePicker from 'vue2-datepicker'
import ReportFilters from '@/components/ReportFilters'
import Icon from '@/components/Icon'
import DonutChart from '@/components/DonutChart'
import BarChart from '@/components/BarChart'
import LineChart from '@/components/LineChart'

export default {
  name: 'ReportSummary',
  components: { ReportFilters, Icon, DatePicker, DonutChart, BarChart, LineChart },
  data () {
    return {
      breadcrumbs: [{text: 'My Vos Voco', to: '/'}, {text: 'Reporting', to: '/reporting', active: true}],
      workflows: [],
      filters: {date_range: {type: 'weeks', count: 14}}
    }
  },
  created () {
    this.fetchWorkflows()
  },
  computed: {
    workflow () {
      if (this.filters.workflow_id) {
        return this.workflows.find((wf) => { return wf.id === this.filters.workflow_id })
      } else {
        return null
      }
    },
    groupBy () {
      if (this.filters.date_range.type === 'custom') {
        return 'weeks'
      } else {
        return this.filters.date_range.type
      }
    },
    groupByDescription () {
      if (this.groupBy === 'weeks') {
        return 'Weekly'
      } else {
        return 'Daily'
      }
    }
  },
  methods: {
    fetchWorkflows () {
      API.get('workflows', {context: 'events', deep: true}, this.$store.getters.authHeaders)
        .then((response) => {
          this.workflows = response.data.workflows
        })
    },
    updateFilters (filters) {
      this.filters = filters
      console.log(filters)
    },
    rootCauseFilters (rootCause) {
      return Object.assign({root_cause_id: rootCause.id}, this.filters)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ReportSummary.vue